import { FormControl, FormLabel, InputGroup, Text, Textarea } from '@chakra-ui/react';

const TextareaInput = ({ label, value, placeholder, onChange }) => (
    <FormControl>
        <FormLabel as={Text} fontSize="14px" fontWeight={700}>
            {label}
        </FormLabel>
        <InputGroup>
            <Textarea value={value} placeholder={placeholder} onChange={onChange} />
        </InputGroup>
    </FormControl>
);

export default TextareaInput;
